module.exports = __webpack_public_path__ + "static_pc/img/cos01.e570cf6b.png";